import resolveUserSteamId from "./resolveUserSteamId.js";

// csrep.gg blocks direct favicon fetches, so this is the cached site favicon.
export const CSREP_ICON_URL = "https://icons.duckduckgo.com/ip3/csrep.gg.ico";
export const VAC_BAN_ICON_URL = "https://vac-ban.com/icon.png";

const STEAM_COMMUNITY_HOST = /^(?:www\.)?steamcommunity\.com$/i;
const CSREP_HOST = /^(?:www\.)?csteamcommunity\.com$/i;
const STEAM_ID64 = /^\d{17}$/;

function parseHttpUrl(value) {
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  try {
    const url = new URL(trimmed);
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return null;
    }
    return url;
  } catch {
    return null;
  }
}

function isSteamCommunityHost(hostname) {
  return STEAM_COMMUNITY_HOST.test(hostname) || CSREP_HOST.test(hostname);
}

function normalizeSteamId64(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const normalized = String(value).trim();
  return STEAM_ID64.test(normalized) ? normalized : null;
}

function steamId64FromProfileUrl(steamProfileUrl) {
  const url = parseHttpUrl(steamProfileUrl);
  if (!url || !isSteamCommunityHost(url.hostname)) {
    return null;
  }

  const match = url.pathname.match(/^\/profiles\/(\d{17})(?:\/|$)/);
  return match ? match[1] : null;
}

function resolveSteamId64(user) {
  return (
    normalizeSteamId64(resolveUserSteamId(user)) ||
    steamId64FromProfileUrl(user?.steamProfileUrl)
  );
}

export function buildCsrepUrl(user) {
  const url = parseHttpUrl(user?.steamProfileUrl);
  if (url && isSteamCommunityHost(url.hostname)) {
    url.protocol = "https:";
    url.hostname = "csteamcommunity.com";
    return url.toString();
  }

  const steamId64 = resolveSteamId64(user);
  return steamId64
    ? `https://csteamcommunity.com/profiles/${steamId64}/`
    : null;
}

export function buildVacBanUrl(user) {
  const steamId64 = resolveSteamId64(user);
  return steamId64 ? `https://vac-ban.com/profiles/${steamId64}` : null;
}
